import { Modal } from "@appkit4/react-components";
import { Button } from "../../components/ReadonlyAwareInputs";

const ConfirmationModal = ({ visible, warnings, onClick, onCancel }) => {
  return (
    <Modal
      initialFocus={false}
      wrapperStyle={{ zIndex: "6000" }}
      title={"⚠️ Confirm Import"}
      ariaLabel={"Import Confirmation Modal"}
      onCancel={onCancel}
      visible={visible}
      modalStyle={{ width: "33.75rem" }}
      footer={
        <>
          <Button onClick={onCancel} kind="secondary">
            Cancel
          </Button>
          <Button kind="primary" onClick={onClick}>
            Confirm
          </Button>
        </>
      }
    >
      {warnings && (
        <p className="bold-text">The following validations did not pass:</p>
      )}
      {warnings?.map((warning) => (
        <>
          <hr style={{ width: "100%", borderTop: "1px solid #ccc" }} />
          <p className="red-text bold-text">{warning.header}</p>
          {warning.messages?.map((message) => (
            <p>{message}</p>
          ))}
        </>
      ))}
    </Modal>
  );
};

export default ConfirmationModal;
